<template>
  <el-dialog
    title="请填写信息"
    :visible.sync="innerVisible"
    width="500px"
    custom-class="custom-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="resetForm"
  >
    <div class="container-callme">
      <p style="margin-bottom: 20px;">
        为了更好的为您服务，请填写下列信息，然后点击"确定"，稍后会有客服人员与您联系。
      </p>

      <div class="form-group" style="display: flex; margin-bottom: 15px;">
        <label style="background-color: #b3e0ff; padding: 10px; width: 100px; text-align: center;">联系人</label>
        <input
          v-model="formData.fullName"
          type="text"
          placeholder="请输入联系人姓名"
          style="flex: 1; padding: 10px; border: 1px solid #ccc;"
        />
      </div>

      <div class="form-group" style="display: flex; margin-bottom: 15px;">
        <label style="background-color: #b3e0ff; padding: 10px; width: 100px; text-align: center;">电话号码</label>
        <input
          v-model="formData.phoneNumber"
          type="tel"
          placeholder="请输入联系人电话"
          style="flex: 1; padding: 10px; border: 1px solid #ccc;"
        />
      </div>

      <div class="form-group" style="display: flex; margin-bottom: 15px;">
        <label style="background-color: #b3e0ff; padding: 10px; width: 100px; text-align: center;">公司名称</label>
        <input
          v-model="formData.companyName"
          type="text"
          placeholder="请输入公司名称"
          style="flex: 1; padding: 10px; border: 1px solid #ccc;"
        />
      </div>

      <div class="form-group" style="display: flex; margin-bottom: 15px;">
        <label style="background-color: #b3e0ff; padding: 10px; width: 100px; text-align: center;">咨询内容</label>
        <input
          v-model="formData.message"
          type="text"
          placeholder="请输入咨询内容"
          style="flex: 1; padding: 10px; border: 1px solid #ccc;"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {saveCustomer} from '@/api/common'
import axios from 'axios';

// 创建API客户端（针对8089端口）
const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/jeecg-boot'
    : 'http://127.0.0.1:8899/jeecg-boot',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 添加请求拦截器
apiClient.interceptors.request.use(config => {
  // 开发环境添加特殊头，帮助调试CORS
  if (process.env.NODE_ENV === 'development') {
    config.headers['X-Debug-Origin'] = window.location.origin;
  }
  return config;
});

export default {
  name: 'CallMeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        fullName: "",
        phoneNumber: "",
        companyName: "",
        message: "",
      },
      submitting: false
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    validateForm() {
      if (!this.formData.fullName.trim()) {
        this.$message.warning('请填写联系人');
        return false;
      }

      if (!this.formData.phoneNumber.trim()) {
        this.$message.warning('请填写电话号码');
        return false;
      }

      if (!this.formData.message.trim()) {
        this.$message.warning('请简单描述你咨询的内容');
        return false;
      }


      return true;
    },

    async submitForm() {
      if (!this.validateForm()) return;

      this.submitting = true;

      try {

        const res = await apiClient.post('/customer/customer/add', this.formData, {
          // 显式设置凭证模式为 false
          withCredentials: false,

          // 添加额外的CORS相关头
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Sec-Fetch-Mode': 'cors'
          }
        });

        if (res.data.success) {
          this.$message.success('提交成功，稍后将有客服联系您');
          this.innerVisible = false;
        } else {
          const errorMsg = res.data.message || '提交失败，服务器未返回成功状态';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        // 特殊处理CORS错误
        if (error.message.includes('CORS') || error.message.includes('Access-Control')) {
          this.$message.error('跨域请求被阻止，请联系管理员');
          console.error('CORS错误详情:', error);

          // 尝试备用方案
          this.tryAlternativeSubmit();
        } else {
          let errorMessage = '提交失败，请稍后再试';
          if (error.response) {
            switch (error.response.status) {
              case 400: errorMessage = '请求参数错误'; break;
              case 401: errorMessage = '身份验证失败'; break;
              case 403: errorMessage = '没有操作权限'; break;
              case 404: errorMessage = 'API地址不存在'; break;
              case 500: errorMessage = '服务器内部错误'; break;
              default:
                if (error.response.data.message) {
                  errorMessage = error.response.data.message;
                }
            }
          }
          this.$message.error(errorMessage);
        }
        console.error('API请求错误:', error);
      } finally {
        this.submitting = false;
      }
    },

    // 备用提交方案
    async tryAlternativeSubmit() {
      try {
        console.log('尝试备用提交方案...');

        // 方案1: 使用原生fetch API
        const response = await fetch('http://127.0.0.1:8089/jeecgboot/customer/customer/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify(this.formData),
          mode: 'cors', // 显式设置cors模式
          credentials: 'omit' // 明确不发送凭证
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        if (data.success) {
          this.$message.success('提交成功（备用方案）');
          this.innerVisible = false;
        } else {
          this.$message.error(data.message || '备用方案提交失败');
        }
      } catch (error) {
        console.error('备用方案错误:', error);
        this.$message.error('所有提交方式均失败，请检查控制台日志');
      }
    },

    resetForm() {
      this.formData = {
        fullName: "",
        phoneNumber: "",
        companyName: "",
        message: "",
      };
    }
  }
};
</script>

<style scoped>
/* 样式保持不变 */
</style>

<style scoped>
.container-callme {
  padding: 20px;
  border-radius: 20px;
}

.form-group input:focus {
  outline: none;
  border-color: #409EFF;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
}

/* 添加响应式调整 */
@media (max-width: 600px) {
  .form-group {
    flex-direction: column;
  }

  .form-group label {
    width: 100% !important;
    margin-bottom: 5px;
  }
}
</style>

<style>
.custom-dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}

/* 防止 body 出现 padding-right */
.v-modal,
.el-dialog__wrapper {
  padding-right: 0 !important;
}

body.modal-open {
  padding-right: 0 !important;
}

/* 增加按钮加载状态样式 */
.el-button--primary.is-loading:before {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/CallMeDialog.vue